import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  PagedPostedAircraftTripAudit,
  PostedAircraftTripSkeleton
} from './+models/trip-manager-audit.model';

@Injectable()
export class TripManagerAuditService {
  private readonly apiUrl = '/sdapi/post-flight/PostedAircraftTripAudit';

  constructor(private readonly http: HttpClient) {}

  getPostedAircraftTripSkeletons(aircraftProfileId: number) {
    return this.http.get<PostedAircraftTripSkeleton[]>(
      `${this.apiUrl}/PostedAircraftTripSkeletons/${aircraftProfileId}`
    );
  }

  getPostedAircraftTripAudit(
    postedAircraftTripId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 25;
    }
    let url = `${this.apiUrl}/${postedAircraftTripId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }

    return this.http.get<PagedPostedAircraftTripAudit>(url);
  }

  getPostedAircraftTripLegAudit(
    postedAircraftTripId: number,
    postedFlightId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 25;
    }
    let url = `${this.apiUrl}/PostedAircraftTripLeg/${postedAircraftTripId}/${postedFlightId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }

    return this.http.get<PagedPostedAircraftTripAudit>(url);
  }
}
